"use client";

import React from "react";

type HighlightBoxProps = {
  title?: string;
  children: React.ReactNode;
  className?: string;
};

const HighlightBox: React.FC<HighlightBoxProps> = ({
  title,
  children,
  className = "",
}) => {
  return (
    <div className={`relative max-w-7xl mx-auto ${className}`}>
      <div className="relative rounded-md border border-[#ccc]/48 bg-white/70 p-4 lg:p-8">

        {/* Left border highlight */}
        <span className="absolute left-0 top-1/2 -translate-y-1/2 h-12 w-[3px] bg-[#d53333] rounded-full" />

        {/* Right border highlight */}
        <span className="absolute right-0 top-1/2 -translate-y-1/2 h-12  w-[3px] bg-[#d53333] rounded-full" />

        <div className="text-center text-base lg:text-md text-[#1b1b1b] leading-snug">
          <p className="max-w-xl lg:max-w-2xl xl:max-w-6xl mx-auto">
            {title && (
              <span className="font-bold text-[#272d57]">
                {title}{" "}
              </span>
            )}
            {children}
          </p>
        </div>
      </div>
    </div>
  );
};

export default HighlightBox;